import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgDirectivesModule, NgPipesModule } from '@libs/frameworks/angular';

import { LegalImprintComponent } from './imprint/imprint.component';
import { LegalPagesComponent } from './legal-pages.component';
import { LegalPrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LegalCookiesUsageComponent } from './cookies-usage/cookies-usage.component';
import { LegalCancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { LegalRoutingModule } from './legal-routing.module';
import { LegalTermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { LegalAffiliateTermsComponent } from './affiliate-terms/affiliate-terms.component';
import { LegalCookiesSettingsComponent } from '../shared/cookies-settings/cookies-settings.component';
import { LegalContentModule } from '../../services/legal-pages/legal-content.module';
import { ILegalPagesConfig } from './legal-pages.interface';


@NgModule({
	declarations: [
		LegalImprintComponent,
		LegalPagesComponent,
		LegalCancellationPolicyComponent,
		LegalPrivacyPolicyComponent,
		LegalCookiesUsageComponent,
		LegalTermsOfUseComponent,
		LegalAffiliateTermsComponent
	],
	imports: [
		CommonModule,
		NgbNavModule,
		NgPipesModule,
		LegalRoutingModule,
		NgDirectivesModule,
		LegalContentModule,
		LegalCookiesSettingsComponent
	],
	exports		: [
		LegalPagesComponent
	]
})
export class LegalPagesModule {

	// setup config
	static register(config: ILegalPagesConfig): ModuleWithProviders<LegalPagesModule> {

		const contentModule: ModuleWithProviders<LegalContentModule> = LegalContentModule.register(config);

		return {
			ngModule	: LegalPagesModule,
			providers	: contentModule.providers
		};
	}
}
